export default class SolicitudDetalleAutorizacion{

    constructor(){
        this.NumeroAutorizacion = "";
        this.TipoAutorizacion = 0;
        this.EntidadAutorizada = "";
        this.EntidadUsuario = "";
    }

      NumeroAutorizacion: string;
      TipoAutorizacion :number;
      EntidadAutorizada : string;
      EntidadUsuario: string;
}